import dayjs from 'dayjs';

export function formatDateTime(date) {
    return dayjs(date).format('DD.MM.YYYY HH:mm');
}

export function formatDate(date) {
    return dayjs(date).format('DD.MM.YYYY');
}

export function isNowBeforeDate(date) {
    if (!date) return true;
    return dayjs().isBefore(dayjs(date, 'YYYY-MM-DD HH:mm'));
}

export function getStartDateFromProgram(program) {
    try {
        return `${program.items[0].startTime} ${program.items[0].items[0].startTime}`;
    } catch (e) {
        return null;
    }
}
